module.exports = "/_next/static/images/f7141b712378f2abf37f6244e210fc3f-icon-1.svg.webp";